import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent, InterpolatableTranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomTranslateService {
    constructor(private translateService: TranslateService) {}

    /**
     * Check if a translation key exists synchronously
     * @param key The translation key to check
     * @returns True if the translation key exists, false otherwise
     */
    keyExists(key: string): boolean {
        return this.translateService.instant(key) !== key;
    }

    addLangs(langs: string[]): void {
        this.translateService.addLangs(langs);
    }

    get currentLang(): string {
        return this.translateService.currentLang;
    }

    get langs(): string[] {
        return this.translateService.langs;
    }

    /**
     * Subscribe to language change events
     * @returns Observable that emits LangChangeEvent
     */
    get onLangChange(): Observable<LangChangeEvent> {
        return this.translateService.onLangChange;
    }

    setDefaultLang(lang: string): void {
        this.translateService.setDefaultLang(lang);
    }

    use(lang: string): Observable<InterpolatableTranslationObject> {
        return this.translateService.use(lang);
    }

    get(key: string, interpolateParams?: object): Observable<string>;
    get(key: string[], interpolateParams?: object): Observable<Record<string, unknown>>;
    get(key: string | string[], interpolateParams?: object): Observable<string | Record<string, unknown>> {
        return this.translateService.get(key, interpolateParams) as Observable<string | Record<string, unknown>>;
    }

    instant<T = string>(key: string | string[], interpolateParams?: object): T {
        return this.translateService.instant(key, interpolateParams) as T;
    }
}
